import storage from 'local-storage-fallback';
import React, { useState, createContext, useContext } from 'react';

import { GIFT_CODE_ENCRYPTION_PASSWORD_KEY_PREFIX } from '@/App/constants';
import { useGacha } from '@/hooks/context/GachaContext';
import CreateGiftCodeCrypto from '@/hooks/context/components/CreateGiftCodeCryptoForm';
import { GiftCodeCrypto } from '@/service/giftCodeCrypto';

type GiftCodeCryptoContextType = {
  giftCodeCrypto: GiftCodeCrypto;
  setGiftCodeCrypto: React.Dispatch<React.SetStateAction<GiftCodeCrypto>>;
};

const GiftCodeCryptoContext = createContext<GiftCodeCryptoContextType | null>(null);

export const useGiftCodeCrypto = () => useContext(GiftCodeCryptoContext);

interface GiftCodeCryptoProviderProps {
  children: React.ReactNode;
}
export default function GiftCodeCryptoProvider({ children }: GiftCodeCryptoProviderProps) {
  const { gacha } = useGacha();
  const [giftCodeCrypto, setGiftCodeCrypto] = useState<GiftCodeCrypto | null>(null);
  const giftCodeCryptoPasswordKey = `${GIFT_CODE_ENCRYPTION_PASSWORD_KEY_PREFIX}${gacha.name}`;
  const giftCodeCryptoPassword = storage.getItem(giftCodeCryptoPasswordKey);

  if (!!giftCodeCryptoPassword && !giftCodeCrypto) {
    setGiftCodeCrypto(new GiftCodeCrypto(giftCodeCryptoPassword));
  }

  const defaultContext = {
    giftCodeCrypto,
    setGiftCodeCrypto,
  };

  return (
    <GiftCodeCryptoContext.Provider value={defaultContext}>
      {giftCodeCrypto ? children : <CreateGiftCodeCrypto />}
    </GiftCodeCryptoContext.Provider>
  );
}
